/* Oath — Statement (moves): 3-state auto-cycling dissolve reveal.
   States cycle 0 (dot-ring pattern) -> 1 (stone image) -> 2 (stone + statement) -> loop,
   advancing every data-interval ms (default 4000). The CSS handles the 0.4s cross-fade
   per state. Cycles ONLY while the section is in view (IntersectionObserver), so it never
   runs off-screen and the user always catches it from the start. Reduced-motion holds the
   statement state and never cycles. Figma 667:3477 (desktop) / 650:3151 (mobile). */
(function () {
  function init(el) {
    if (!el || el.dataset.cycleInit === '1') return;
    el.dataset.cycleInit = '1';

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.dataset.state = '2'; // hold the statement-visible state, no motion
      return;
    }

    var interval = parseInt(el.dataset.interval, 10) || 4000;
    var timer = null;
    var state = 0;

    function tick() {
      state = (state + 1) % 3;
      el.dataset.state = String(state);
    }
    function start() { if (!timer) timer = setInterval(tick, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) start(); else stop();
        }
      }, { threshold: 0.3 });
      io.observe(el);
    } else {
      start();
    }
  }

  function boot() {
    var els = document.querySelectorAll('oath-statement-moves');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('oath-statement-moves') : null;
    if (el) { el.dataset.cycleInit = ''; init(el); }
  });
})();
